<template>
  <div>
    <section class="fxt-template-layout10">
      <v-container fluid class="pa-0">
        <v-layout row wrap>
          <v-flex md6 class="col-12 fxt-bg-img" data-bg-image="../../../static/img/bg14-l.jpg">
            <div class="fxt-header">
                <div>
                    <h1 class="black--text">{{$t('header.analyst')}} </h1>
                </div>
                <div>
                    <p class="black--text">{{$t('header.paidTitle')}}</p>
                </div>
            </div>
          </v-flex>
          <v-flex md6 class="col-12 fxt-bg-color">
            <div class="fxt-content">                            
                <div class="fxt-form">                               
                  <h2>{{$t("register.create")}}</h2>
                <!--**********************   vuetify表单   ************************************************** -->
                    <v-form ref="registrationForm" v-model="valid" class="mt-5"> 
                      <v-layout row wrap>
                        <v-flex xs6>
                            <v-text-field class="pr-3" v-model="registrationForm.regEmail" :rules="regEmailRules" :label="$t('register.email')" required></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                            <v-text-field v-model="registrationForm.userName" :rules="userNameRules" :label="$t('register.username')" required></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field type="password" class="pr-3" v-model="passwordForm.passWord" :rules="passWordRules" :label="$t('register.password')" required></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field type="password" v-model="passwordForm.repassWord" :rules="repassWordRules" :label="$t('register.confirmationPassword')" required></v-text-field>
                        </v-flex>
                      </v-layout>             
                      <v-text-field v-model="registrationForm.fillInvitationCode" :label="$t('register.invitationCode')" required></v-text-field>
                      <v-checkbox v-model="registrationForm.agreed" color="primary" :rules="agreedRules">
                        <div slot="label" @click="termsModal = true" class="font-14">
                          {{$t("register.agree")}}
                          <span class="primary--text pointer font-14">
                            <<{{$t("register.terms")}}>>
                          </span>
                        </div>
                      </v-checkbox>
                      <div class="d-flex text-xs-left mt-3">
                        <v-btn medium class="primary ml-0" dark :loading="loading" @click="submitForm">{{$t("register.signUp")}}</v-btn>
                        <v-btn medium class="primary" dark @click="clearForm">{{$t("register.reset")}}</v-btn>
                      </div>
                      <div class="mt-5 fxt-footer font-14">
                        Already a Account?
                        <span @click="gotoLogin" class="primary--text pointer mr-2">{{$t("header.login")}}</span>
                      </div>
                    </v-form>
                    <!--********************************************************************************** -->
                    <!--条款弹出框-->
                    <Modal v-model="termsModal" width="80%" :title="$t('serviceTerms.title')" ok-text="OK" cancel-text="Cancel" @on-ok="agreeTerms">
                    <!-- 条款组件-->
                      <app-terms></app-terms>
                     <!--条款弹出框-->
                    </Modal>
                    <Modal v-model="sendEmailModal">
                      <div class="text-center h4 fw-bold mt-3">
                        <p>{{$t("register.noActivatedMessage")}}</p>
                        <p>{{$t("register.sendEmailMessage")}}</p>
                      </div>
                      <div slot="footer">
                        <Button class="text-white primary" @click="closeSendEmailModal">{{$t("common.no")}}</Button>
                        <Button class="text-white primary" @click="sendActivationEmail">{{$t("common.yes")}}</Button>
                      </div>
                    </Modal>               
                    </div> 
                    <div class="fxt-footer">
                        <ul class="fxt-socials">
                            <li class="fxt-twitter fxt-transformY-50 fxt-transition-delay-7">
                                <a href="https://twitter.com/ioBots_" title="twitter"><i class="fab fa-twitter"></i></a>
                            </li>
                            <li class="fxt-twitter fxt-transformY-50 fxt-transition-delay-7">
                                <a href="https://twitter.com/ioBotsPro" title="twitter"><i class="fab fa-twitter"></i></a>
                            </li>
                            <li class="fxt-linkedin fxt-transformY-50 fxt-transition-delay-9">
                                <a href="https://t.me/iob_llc" title="Telegram"><i class="fab fa-telegram-plane"></i></a>
                            </li>
                        </ul>
                    </div>
                </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>  
  </div>
</template>
<script>
import Md5 from "js-md5";
import $ from 'jquery';
import config from "../../config.js";
export default {
  data() {
    /*用户名的判断*/
    const userName = (rule, value, callback) => {
      var uPattern = /^[a-zA-Z0-9_-]{4,16}$/;
      if (value == 0) {
        callback(new Error(this.$t("register.errorCallback.userName.empty")));
      } else if (!uPattern.test(value)) {
        callback(new Error(this.$t("register.errorCallback.userName.value")));
      } else {
        this.$http
          .post(
            config.baseUrl + "user/open/register/validationName",
            this.formInline
          )
          .then(successData => {
            let data = successData.data;
            if (data.resCode == 1) {
              callback(
                new Error(this.$t("register.errorCallback.userName.exist"))
              );
            } else {
              callback();
            }
          });
      }
    };
    /*密码的判断*/
    const passWord = (rule, value, callback) => {
      let passreg = /^.*(?=.{8,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/;
      if (value == 0) {
        callback(new Error(this.$t("register.errorCallback.passWord.empty")));
      } else if (!passreg.test(value)) {
        callback(new Error(this.$t("register.errorCallback.passWord.value")));
      } else {
        callback();
      }
    };
    /*再次输入密码的判断*/
    const repassWord = (rule, value, callback) => {
      if (value == 0) {
        callback(new Error(this.$t("register.errorCallback.repassWord.empty")));
      } else if (value !== this.formInline.passWord) {
        callback(new Error(this.$t("register.errorCallback.repassWord.value")));
      } else {
        callback();
      }
    };
    /*验证邮箱的判断*/
    const regEmail = (rule, value, callback) => {
      let Emailyz = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      if (value == 0) {
        callback(new Error(this.$t("register.errorCallback.regEmail.empty")));
      } else if (!Emailyz.test(value)) {
        callback(new Error(this.$t("register.errorCallback.regEmail.format")));
      } else {
        this.$http
          .post(
            config.baseUrl + "user/open/register/validationEmail",
            this.formInline
          )
          .then(successData => {
            let data = successData.data;
            if (data.resCode == 1) {
              callback(
                new Error(this.$t("register.errorCallback.regEmail.exist"))
              );
            } else {
              callback();
            }
          });
      }
    };
    /*是否同意协议的判断*/
    const agreed = (rule, value, callback) => {
      //Please read and agreed with the currency user agreement
      if (value == false) {
        callback(new Error(this.$t("register.invitationNotempty")));
      } else {
        callback();
      }
    };
    return {
      //*****v-form表单数据***************************//
      valid: true,
      domainName: config.ip,
      passwordForm: {
        //密码表单
        passWord: "",
        repassWord: ""
      },
      registrationForm: {
        //注册用户表单
        userName: "",
        passWord: "",
        repassWord: "",
        regEmail: "",
        status: -1,
        agreed: false,
        fillInvitationCode: ""
      },
      regEmailRules: [
        v => !!v || this.$t("register.errorCallback.regEmail.empty"),
        v =>
          /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(
            v
          ) || this.$t("register.errorCallback.regEmail.format")
      ],
      userNameRules: [
        v => !!v || this.$t("register.errorCallback.userName.empty"),
        v =>
          /^[a-zA-Z0-9_-]{4,16}$/.test(v) ||
          this.$t("register.errorCallback.userName.value")
      ],
      passWordRules: [
        v => !!v || this.$t("register.errorCallback.passWord.empty"),
        //  .*(?=.{8,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*
        v =>
          /^(?=.*\d)(?=.*[A-Za-z]).{8,20}$/.test(v) ||
          this.$t("register.errorCallback.passWord.value")
      ],
      repassWordRules: [
        v => !!v || this.$t("register.errorCallback.repassWord.empty"),
        v =>
          v == this.passwordForm.passWord ||
          this.$t("register.errorCallback.repassWord.value")
      ],
      agreedRules: [v => !!v || this.$t("register.invitationNotempty")],
      //********************************//

      isShowNoticeModal: true, //是否显示通知模态框
      loading: false, //注册按钮的加载中
      formInline: {
        userName: "",
        passWord: "",
        repassWord: "",
        regEmail: "",
        status: -1,
        agreed: "",
        fillInvitationCode: ""
      },
      ruleInline: {
        userName: [{ required: true, validator: userName, trigger: "change" }],
        passWord: [{ required: true, validator: passWord, trigger: "blur" }],
        repassWord: [
          { required: true, validator: repassWord, trigger: "blur" }
        ],
        regEmail: [{ required: true, validator: regEmail, trigger: "blur" }],
        agreed: [{ required: true, validator: agreed, trigger: "blur" }]
      },
      termsModal: false, //条款模态框
      sendEmailModal: false //发送验证邮件模态框
    };
  },
  mounted() {
    //浏览器窗口发生变化时同时变化DIV高度
    // window.onresize=this.autodivheight();
    // 加载邀请码
    this.getInvitationCode();
    this.background();
  },
  methods: {
    //自动获得div高度
    autodivheight() {
      //函数：获取尺寸
      //获取浏览器窗口高度
      // var winHeight=0;
      // if (window.innerHeight){
      //     winHeight = window.innerHeight;
      // }else if ((document.body) && (document.body.clientHeight)){
      //     winHeight = document.body.clientHeight;
      // }//通过深入Document内部对body进行检测，获取浏览器窗口高度
      // if (document.documentElement && document.documentElement.clientHeight){
      //     winHeight = document.documentElement.clientHeight;
      // }
      // alert(winHeight);
      // alert("document.body.offsetHeight:"+document.body.offsetHeight);
      // alert("document.body.scrollHeight:"+document.body.scrollHeight);
      // alert("document.body.clientHeight:"+document.body.clientHeight);
      // alert(window.screen.height);
      //DIV高度为浏览器窗口的高度:winHeight - 66
      // document.getElementById("content").style.height= winHeight +"px";
    },
    background(){
        $("[data-bg-image]").each(function() {
          var img = $(this).data("bg-image");
            $(this).css({
              backgroundImage: "url(" + img + ")"
            });
        })
    },
    //关闭通知模态框
    closeNoticeModal() {
      this.isShowNoticeModal = false;
      this.$router.push({ name: "home" });
    },
    //从链接中获得邀请码
    getInvitationCode() {
      let url = window.location.href;
      let invitationCode = url.substring(url.lastIndexOf("=") + 1);
      if (invitationCode.match("://") === null) {
        this.registrationForm.fillInvitationCode = invitationCode;
      }
    },
    //同意条款
    agreeTerms() {
      this.registrationForm.agreed = true;
    },
    //跳转到主页
    goHome() {
      window.location.href = config.ip;
    },
    gotoLogin() {
      this.$router.push({ name: "posts" });
      this.$store.state.loginModal = true;
    },
    //关闭发送邮件的模态框
    closeSendEmailModal() {
      this.sendEmailModal = false;
    },
    //发送激活邮件
    sendActivationEmail() {
      let url = config.baseUrl + "user/open/register/sendEmail"; //发送邮箱验证
      this.$http.post(url, this.registrationForm).then(successData => {
        let data = successData.data;
        if (data.resCode == 0) {
          if (data.resCode == 0) {
            //发送成功
            this.sendEmailModal = false;
            this.$Message.success({
              content: this.$t("register.registerSuccess"),
              duration: 10,
              closable: true
            });
            this.$refs.registrationForm.reset();
            this.$router.push({ name: "home" });
          }
        }
      });
    },
    /*注册表单验证提交*/
    /*
  handleSubmit(name) {
    this.$refs[name].validate((valid) => {
      if (valid) {
       this.loading = true;
       let url = config.baseUrl + "user/open/register/validationName";     //验证用户名是否存在
       let passWord = Md5(this.formInline.passWord);
       passWord = passWord.split('').reverse().join('');
       this.formInline.passWord = Md5(passWord);
       this.formInline.repassWord = Md5(this.formInline.repassWord);
       let that = this;
       this.$http.post(url,this.formInline).then(function(successData){

         let data =successData.data;
         if (data.resCode==1) {
          this.formInline.passWord = '';
          this.formInline.repassWord = '';
          this.$Message.error({
            content: this.$t('register.errorCallback.userName.exist'),
            duration: 5
          });
          this.loading = false;
        }else  {
          let url = config.baseUrl + "user/open/register/validationEmail";    //验证邮箱是否存在
          let that = this;
          this.$http.post(url,this.formInline).then(function(successData){                             
           let data = successData.data;
           if (data.resCode==1) {
            this.formInline.passWord = '';
            this.formInline.repassWord = '';
            this.$Message.error({
              content: this.$t('register.errorCallback.regEmail.exist'),
              duration: 5
            });
            this.loading = false;
          }
          else {
              let url = config.baseUrl + "user/open/register/editInfo"; //用户新增
              let that = this;
              this.$http.post(url,this.formInline).then(function(successData){
                let data = successData.data;
                if (data.resCode==0) {
                    //数据添加成功，发送邮件
                    let url = config.baseUrl + "user/open/register/sendEmail";   //发送邮箱验证
                    let that = this;
                    this.$http.post(url,this.formInline).then(function(successData){
                      let data = successData.data;
                      if (data.resCode==0) {
                    //发送成功
                    this.$Message.success({
                      content:this.$t('register.registerSuccess'),
                      duration:8
                    });
                    this.loading = false;
                    this.$refs[name].resetFields();
                    this.$router.push({name:'home'});
                  }
                },function(errorData){
                  this.$Message.error(this.$t("common.fail"));
                  this.loading = false;
                });
                  }
                },function(errorData){
                 this.$Message.error(this.$t("common.fail"));
                 this.loading = false;
               });
            }
          },function(errorData){
           this.$Message.error(this.$t("common.fail"));
           this.loading = false;
         });
        }
      },function(errorData){
        this.$Message.error(this.$t("common.fail"));
        this.loading = false;
      });
     } else {
      this.$Message.error(this.$t("common.fail"));
      this.loading = false;
    }
  })
  },  
  */

    //vuetify提交表单
    submitForm() {
      if (this.$refs.registrationForm.validate()) {
        this.loading = true;
        //验证邮箱是否存在
        let url = config.baseUrl + "user/open/register/validationEmail";
        let sha256 = require("js-sha256").sha256;
        let passWord = sha256(this.passwordForm.passWord);
        let repassWord = sha256(this.passwordForm.repassWord);
        this.registrationForm.passWord = passWord;
        this.registrationForm.repassWord = repassWord;
        this.$http.post(url, this.registrationForm).then(
          successData => {
            let data = successData.data;
            if (data.resCode == 1) {
              this.registrationForm.passWord = "";
              this.registrationForm.repassWord = "";
              this.$Message.error({
                content: this.$t("register.errorCallback.regEmail.exist"),
                duration: 10,
                closable: true
              });
              this.loading = false;
            } else if (data.resCode == -1) {
              //当前邮箱已经注册但未激活，请激活, 打开发送邮件的modal
              this.sendEmailModal = true;
              this.loading = false;
            } else {
              //验证用户名是否存在
              let url = config.baseUrl + "user/open/register/validationName";
              this.$http.post(url, this.registrationForm).then(
                successData => {
                  let data = successData.data;
                  if (data.resCode == 1) {
                    this.registrationForm.passWord = "";
                    this.registrationForm.repassWord = "";
                    this.$Message.error({
                      content: this.$t("register.errorCallback.userName.exist"),
                      duration: 10,
                      closable: true
                    });
                    this.loading = false;
                  } else {
                    if (
                      this.registrationForm.passWord == null &&
                      this.registrationForm.passWord == ""
                    ) {
                      this.$Message.error(this.$t("common.fail"));
                      this.loading = false;
                      return;
                    }
                    //用户新增
                    let url = config.baseUrl + "user/open/register/editInfo";
                    this.registrationForm.passWord = passWord;
                    this.registrationForm.repassWord = repassWord;
                    this.$http.post(url, this.registrationForm).then(
                      successData => {
                        let data = successData.data;
                        if (data.resCode == 0) {
                          //数据添加成功，发送邮件
                          let url =
                            config.baseUrl + "user/open/register/sendEmail"; //发送邮箱验证
                          this.$http.post(url, this.registrationForm).then(
                            successData => {
                              let data = successData.data;
                              if (data.resCode == 0) {
                                //发送成功
                                this.$Notice.success({
                                  title: this.$t("common.success"),
                                  desc: this.$t("register.registerSuccess"),
                                  duration: 0
                                });
                                this.loading = false;
                                this.$refs.registrationForm.reset();
                                this.$router.push({ name: "home" });
                              }
                            },
                            errorData => {
                              this.$Message.error(this.$t("common.fail"));
                              this.loading = false;
                            }
                          );
                        }
                      },
                      errorData => {
                        this.$Message.error(this.$t("common.fail"));
                        this.loading = false;
                      }
                    );
                  }
                },
                errorData => {
                  this.$Message.error(this.$t("common.fail"));
                  this.loading = false;
                }
              );
            }
          },
          errorData => {
            this.$Message.error(this.$t("common.fail"));
            this.loading = false;
          }
        );
      } else {
        //没有通过表单验证
        this.$Message.error(this.$t("common.fail"));
        this.loading = false;
      }
    },
    //清除表单
    clearForm() {
      this.$refs.registrationForm.reset();
    }
  }
};
</script>


// WEBPACK FOOTER //
// Register.vue?4f192f3e